import React from 'react';
import { useIntl } from 'react-intl';

import Banner from '@/components/Base/Banner';
import PageBreadcrumbs from '@/components/Base/PageBreadcrumbs';
import CompanyPageContent from '@/components/Pages/CompanyPage/CompanyPageContent';
import CompanyPageHeader from '@/components/Pages/CompanyPage/CompanyPageHeader';
// import NotFoundPage from '@/components/Pages/NotFoundPage';
import { BANNERS } from '@/constants';
import { usePageProps } from '@/hooks';
import { useGetOrganizationBySlugQuery } from '@/queries';

import { BreadcrumbsWrapper, LayoutStyles } from './CompanyPage.styles';

function CompanyPage() {
  const pageProps = usePageProps();
  const { locale } = useIntl();

  const { params } = pageProps;

  const { data: companyData = {} } = useGetOrganizationBySlugQuery(
    {
      locale,
      slug: params?.companySlug,
    },
    { skip: !params?.companySlug }
  );

  return (
    <LayoutStyles dataTestId="company-page">
      {companyData?.id && <CompanyPageHeader {...companyData} />}

      <CompanyPageContent />

      <BreadcrumbsWrapper>
        <Banner {...BANNERS.catfish} />

        <PageBreadcrumbs />
      </BreadcrumbsWrapper>
    </LayoutStyles>
  );
}

export default CompanyPage;
